// extracted by mini-css-extract-plugin
export default {"container":"MultipleProgressBar_container__PKWwO","progressSlice":"MultipleProgressBar_progressSlice__caYfK font-md-regular"};